<template>
  <card title="Filters">
    <div class="row">
      <div class="col-md-3 pr-md-1">
        <base-input
          placeholder="Agency name (min 3 chars)"
          v-model="filters.name"
        />
      </div>
      <div class="col-md-2 px-md-1">
        <el-select
          v-model="filters.iso_code"
          placeholder="Country"
          no-data-text="No data"
          no-match-text="No match"
          filterable
          clearable
        >
          <el-option
            v-for="country in countries"
            :key="country.code"
            :label="country.name.en"
            :value="country.code"
          />
        </el-select>
      </div>
      <div class="col-md-2 px-md-1">
        <el-select
          v-model="filters.manager_id"
          placeholder="Account manager"
          no-data-text="No data"
          no-match-text="No match"
          filterable
          clearable
        >
          <el-option
            v-for="manager in filterManagers"
            :key="manager.id"
            :label="manager.name"
            :value="manager.id"
          />
        </el-select>
      </div>
      <div class="col-md-2 px-md-1">
        <el-select v-model="filters.is_hide" placeholder="Visibility" clearable>
          <el-option label="Active" :value="false" />
          <el-option label="Hidden" :value="true" />
        </el-select>
      </div>
      <div class="col-md-3 px-md-1">
        <base-button @click="clearFilters">Clear filters</base-button>
        <base-button v-if="canManageAgencies" class="ml-2 add-partner-btn" @click="openAddPartnerModal">
          Add partner
        </base-button>
      </div>
    </div>

    <AddPartnerModal :show.sync="isAddPartnerModalVisible" />
  </card>
</template>

<script>
import agencyAccess from '@/components/Agencies/agencyAccess';
import { mapState, mapActions } from 'vuex';
import AddPartnerModal from '@/components/Clinics/AddPartnerModal';

export default {
  mixins: [agencyAccess],
  components: {
    AddPartnerModal,
  },
  props: ['page'],
  data: () => ({
    filters: {
      name: '',
      iso_code: '',
      manager_id: null,
      is_hide: null,
    },
    isAddPartnerModalVisible: false,
  }),
  computed: {
    ...mapState('cmsApiCatalogs', ['countries']),
    ...mapState('agencies', ['filterManagers']),
  },
  watch: {
    filters: {
      immediate: true,
      deep: true,
      handler: 'fetchAgencies',
    },
    page() {
      this.fetchAgencies(this.page);
    },
  },
  created() {
    this.getCountries({ perPage: 1500 });
    this.getManagers();
  },
  methods: {
    ...mapActions('cmsApiCatalogs', ['getCountries']),
    ...mapActions('agencies', ['getAgencies', 'getManagers']),
    buildParams(currentPage) {
      const params = {};
      if (this.filters.name && this.filters.name.length >= 3) {
        params.name = this.filters.name;
      }
      if (this.filters.iso_code) {
        params.iso_code = this.filters.iso_code;
      }
      if (this.filters.manager_id !== null) {
        params.manager_id = this.filters.manager_id;
      }
      if (this.filters.is_hide !== null) {
        params.is_hide = this.filters.is_hide ? 1 : 0;
      }
      if (currentPage) {
        params.page = currentPage;
      }
      return params;
    },
    fetchAgencies(filtersOrPage) {
      let page = null;
      if (!isNaN(filtersOrPage)) {
        page = filtersOrPage;
      } else {
        this.$emit('reset-page');
      }
      const params = this.buildParams(page);
      this.$store.dispatch('setLoader', true);
      this.getAgencies(params).finally(() => this.$store.dispatch('setLoader', false));
    },
    clearFilters() {
      this.filters = { name: '', iso_code: '', manager_id: null, is_hide: null };
      this.$emit('reset-page');
    },
    openAddPartnerModal() {
      if (!this.canManageAgencies) return;
      this.isAddPartnerModalVisible = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.add-partner-btn {
  &,
  &:hover,
  &:focus,
  &:active {
    background-color: #a3cc0e !important;
    background-image: none !important;
    border-color: #a3cc0e !important;
    color: #fff;
  }
}
</style>
